var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon19(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 41.25V31.875C37.5 28.3406 37.5 26.5725 36.4012 25.4738C35.3025 24.375 33.5363 24.375 30 24.375L22.5 41.25L15 24.375C11.4637 24.375 9.6975 24.375 8.59875 25.4738C7.5 26.5725 7.5 28.3406 7.5 31.875V41.25",
    stroke: "#55749F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 24.375L22.5 28.125L24.375 24.375H20.625Z",
    fill: "#55749F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 28.125L21.5625 35.625L22.5 38.4375L23.4375 35.625L22.5 28.125Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 28.125L21.5625 35.625L22.5 38.4375L23.4375 35.625L22.5 28.125ZM22.5 28.125L20.625 24.375H24.375L22.5 28.125Z",
    stroke: "#55749F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 12.3125V14.1875C29.0625 15.0493 28.8928 15.9027 28.563 16.6989C28.2332 17.4951 27.7498 18.2185 27.1404 18.8279C26.531 19.4373 25.8076 19.9207 25.0114 20.2505C24.2152 20.5803 23.3618 20.75 22.5 20.75C21.6382 20.75 20.7848 20.5803 19.9886 20.2505C19.1924 19.9207 18.469 19.4373 17.8596 18.8279C17.2502 18.2185 16.7668 17.4951 16.437 16.6989C16.1072 15.9027 15.9375 15.0493 15.9375 14.1875V12.3125C15.9375 10.572 16.6289 8.90282 17.8596 7.67211C19.0903 6.4414 20.7595 5.75 22.5 5.75C24.2405 5.75 25.9097 6.4414 27.1404 7.67211C28.3711 8.90282 29.0625 10.572 29.0625 12.3125Z",
    stroke: "#55749F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon19);
export default __webpack_public_path__ + "static/media/icon19.58f9ee073a123413abb7fbbf2a9304a6.svg";
export { ForwardRef as ReactComponent };